import React, { Component } from 'react';
import '../../App.css';

import fruit from '../../img/fruit.png'
import fish from '../../img/fish.png'
import roses from '../../img/roses.png'

class products extends Component {
  render() {
    return (
      <div className="products">
          <span>PRODUCTS</span><br/>
          <div className="three-items">
            <div className="item">
              <img src={fruit} alt=""/>
              <span><a href="/en/pioricost-fruit">
                <button>Know More</button>
                </a></span>
            </div>
            <div className="item">
              <img src={fish} alt=""/>
              <span><a href="/pioricost-fruit">
                <button disabled>Soon</button>
                </a></span>
            </div>
            <div className="item">
              <img src={roses} alt=""/>
              <span><a href="/pioricost-fruit">
                <button disabled>Soon</button>
                </a></span>
            </div>
          </div>
      </div>
    );
  }
}

export default products;


// WEBPACK FOOTER //
// ./src/components/en-home/products.js